'use strict';

angular.module('amexReconciliationApp')
  .component('transactionReceipts', {
    templateUrl: 'scripts/views/components/transaction-receipts.html',
    controller: function ($uibModal,
                          $rootScope,
                          TransactionReceiptService,
                          ReceiptService,
                          ActiveTransactionModel,
                          TransactionSearchModel) {
      var self = this;

      self.readonly = function () {
        return ReceiptService.receiptUploadingIsLocked() ||
          TransactionSearchModel.isLimitedRole();
      };

      self.receipts = ActiveTransactionModel.receipts;
      self.activeTransaction = ActiveTransactionModel.activeTransaction();

      self.unmatchButtonClicked = function unmatchButtonClicked(unmatchedReceipt) {
        if (self.readonly()) {
          return;
        }

        TransactionReceiptService.unmatchReceiptFromTransaction(unmatchedReceipt, self.activeTransaction)
          .then(function (receipts) {
            self.activeTransaction.receiptIds = _.map(receipts, 'id');
          });
      };

      self.viewReceipt = function viewReceipt(receipt) {
        if (!ReceiptService.isReceiptViewable(receipt)) {
          return;
        }

        var scopeWithReceipt = $rootScope.$new();
        scopeWithReceipt.receipt = receipt;
        $uibModal.open({
          template: '<receipt-view-modal receipt="receipt" close-modal-callback="$close()"></receipt-view-modal>',
          size: 'md',
          scope: scopeWithReceipt
        });
      };

      self.isReceiptViewable = ReceiptService.isReceiptViewable;

    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionReceipts.js
// module id = 497
// module chunks = 0